document.addEventListener('click', function (event) {
  var link = event.target.closest('a[href]');
  if (!link) return;

  var href = link.getAttribute('href') || '';
  var isAmazonLink = href.indexOf('amazon.') !== -1 || href.indexOf('amzn.to') !== -1;

  if (isAmazonLink && typeof fbq === 'function') {
    try {
      fbq('trackCustom', 'AmazonClick', {
        link_url: href,
        page_url: window.location.href,
        page_title: document.title
      });
    } catch (err) {
      // Never let tracking errors interfere with the actual link click
    }
  }
}, true);